import { getApi, postApi } from "./helpers/apiMethods";
import type {
  InteractionSummary,
  GenerateSummaryResponse,
  TranscribeAndSummarizeResponse,
} from "../types/summary/Summary";
import type { RedactionOptions } from "./transcription";

export async function getSummary(
  customerId: string,
  interactionId: string,
): Promise<InteractionSummary | null> {
  try {
    const response = await getApi<InteractionSummary>(
      `/v1/customers/${customerId}/interactions/${interactionId}/summary`,
    );
    return response.data ?? null;
  } catch {
    return null;
  }
}

export async function generateSummary(
  customerId: string,
  interactionId: string,
  templateId?: string,
): Promise<GenerateSummaryResponse> {
  const response = await postApi<GenerateSummaryResponse>(
    `/v1/customers/${customerId}/interactions/${interactionId}/summary`,
    { templateId },
  );
  if (!response.data) {
    throw new Error("Failed to generate summary.");
  }
  return response.data;
}

export async function transcribeAndSummarize(
  customerId: string,
  interactionId: string,
  redactionOptions?: RedactionOptions,
): Promise<TranscribeAndSummarizeResponse> {
  const response = await postApi<TranscribeAndSummarizeResponse>(
    `/v1/customers/${customerId}/interactions/${interactionId}/transcribe-and-summarize`,
    { redactionOptions },
  );
  if (!response.data) {
    throw new Error("Failed to start transcribe and summarize.");
  }
  return response.data;
}
